export const ProfileMenuItems = [
  {
    name: 'Overview',
    link: '#overview',
    component: () => import('@/app/profile/tabs/OverviewTab'),
  },
  {
    name: 'Your Dogs',
    link: '#yourdogs',
    component: () => import('@/app/profile/tabs/YourDogs'),
  },
  {
    name: 'Health',
    link: '#medical',
    component: () => import('@/app/profile/tabs/HealthTab'),
  },
  {
    name: 'Nutrition',
    link: '#nutrition',
    component: () => import('@/app/profile/tabs/NutritionTab'),
  },
  {
    name: 'Settings',
    link: '#settings',
    component: () => import('@/app/profile/tabs/SettingsTab'),
  },
];

export const ProfileMenuParticipantItems = [
  {
    name: 'Overview',
    link: '#overview',
    component: () => import('@/app/profile/tabs/OverviewTab'),
  },
  {
    name: 'Team and Staff',
    link: '#teamstaff',
    component: () => import('@/app/profile/tabs/TeamStaff'),
  },
  {
    name: 'Active Listings',
    link: '#listings',
    component: () => import('@/app/profile/tabs/ActiveListings'),
  },
  {
    name: 'Reviews and Ratings',
    link: '#reviews',
    component: () => import('@/app/profile/tabs/ReviewsAndRatings'),
  },
  {
    name: 'Settings',
    link: '#settings',
    component: () => import('@/app/profile/tabs/SettingsTab'),
  },
];
